module.exports = __webpack_public_path__ + "static/assets/ba927aa23603e282704613941acd7d08.png";